import { Chip, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { roleSpecialtyKey, roleSpecialtyLabel } from './helpers';
import { RoleSpecialtyOption } from './types';

interface RoleSpecialtyChipsProps {
    value: RoleSpecialtyOption[];
}

/** Read-only chip list rendering (role, speciality) entries with the shared label/key helpers. */
export default function RoleSpecialtyChips({ value }: RoleSpecialtyChipsProps) {
    const { t } = useTranslation('rolesSpecialtiesSelector');

    return (
        <ChipsContainer>
            { value.map(v => (
                <Chip
                    key={ roleSpecialtyKey(v) }
                    variant="outlined"
                    label={ roleSpecialtyLabel(v, t) }
                />
            )) }
        </ChipsContainer>
    );
}

const ChipsContainer = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    alignItems: 'center'
}));
